import withAemIntegration from "../../../withAemIntegration";
import serviceParser, { dealerDataMap } from "../../../utils/serviceParser";

import loadable from "../../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/components/DealerContacts")
);

const DealerContactsEditConfig = {
  emptyLabel: "DealerContacts",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const checkEspanol = (programs) => {
  let isEspanol = false;
  programs.forEach((item) => {
    if (item.code === "SpanishSpeaking") {
      isEspanol = true;
    }
  });
  return isEspanol;
};

const getHours = (whichTile) => {
  let daysOpen =
    whichTile === "{salesHours}"
      ? window.LEXUS.dealerData.hoursOfOperation.Sales
      : window.LEXUS.dealerData.hoursOfOperation.Service;
  if (!daysOpen) return false;
  let openHours = "";
  for (const days in daysOpen) {
    openHours += days + ": " + daysOpen[days] + "<br/>";
  }
  return openHours;
};

const buildTiles = (tiles) => {
  if (tiles.length < 1) return;

  return tiles.reduce((acc, tile) => {
    const description =
      tile.description === "{salesHours}" ||
      tile.description === "{serviceHours}"
        ? getHours(tile.description) || tile.noInfoMessage
        : serviceParser(tile.description, dealerDataMap);
    if (!description) {
      return acc;
    }
    return [
      ...acc,
      {
        heading: serviceParser(tile.heading, dealerDataMap),
        subHeading:
          tile.subHeading &&
          checkEspanol(window.LEXUS.dealerData.dealerPrograms)
            ? tile.subHeading + "<br/>"
            : "",
        description,
        ctaPhone: {
          ...tile.cta,
          href: serviceParser(tile.cta?.href, dealerDataMap),
          text: serviceParser(tile.cta?.text, dealerDataMap),
        },
      },
    ];
  }, []);
};

const transformData = (props) => {
  return {
    id: "DealerContacts",
    heading: props.heading,
    textColor: props.textColor || "#000",
    tiles: buildTiles(props.tiles),
    mobileCarousel: props.mobileCarousel || false,
    disclaimerMessage: props.disclaimerText,
  };
};

const DealerContacts = (props) => {
  const data = transformData(props);

  return <Component {...data} />;
};
export default withAemIntegration(
  "lexus/components/dealer-details/dealer-contacts"
)(DealerContacts, DealerContactsEditConfig);
